import { render, staticRenderFns } from "./TheCompareDocuments.vue?vue&type=template&id=ef60b4c6&scoped=true&"
import script from "./TheCompareDocuments.vue?vue&type=script&lang=js&"
export * from "./TheCompareDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TheCompareDocuments.vue?vue&type=style&index=0&id=ef60b4c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef60b4c6",
  null
  
)

export default component.exports